import React from 'react';
import { useDispatch } from 'react-redux';
import { Modal, ModalBody } from 'reactstrap';
import { isVisible } from 'slices/loader/reducer';
import './Modal.scss';
import Logo from '../../assets/images/Logo.png';

interface LoaderModalProps {
  isOpen: boolean;
}

export default function LoaderModal({ isOpen }: LoaderModalProps) {
  const dispatch = useDispatch();

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        dispatch(isVisible(false));
      }}
      centered
      className="loader-modal"
    >
      <ModalBody>
        <img
          src={Logo}
          alt="MPM"
          style={{
            width: '437px',
            height: '300px',
            marginLeft: '-15%',
            marginBottom: '10px',
          }}
        />
      </ModalBody>
    </Modal>
  );
}
